module.exports = __webpack_public_path__ + "img/img1.cb6179fc.png";